export default __webpack_public_path__ + "static/media/Samsung Galaxy S7.e251cdb3.png";